import React, { useEffect, useState } from "react";
import logo2 from "../assets/logo6.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaXmark } from "react-icons/fa6";
import {
  Modal,
  Button,
  Dropdown,
  DropdownToggle,
  Row,
  Col,
  DropdownMenu,
} from "react-bootstrap";
import OrderBtn from "../utils/OrderBtn";
import RollingMarquee from "../utils/Marque";
import config from "../config";
import axios from "axios";
import { BiCaretDown } from "react-icons/bi";

const Navbar = ({locationArray, targetedLocation, call, setLocationName, categoryList }) => {
  const [stickyNavbar, setStickyNavbar] = useState(false);
  const [mobileNavbar, setMobileNavbar] = useState(false);
  const [showLocations, setShowLocations] = useState(false);
  const [menu, setMenu] = useState(false);
  const [displayText, setDisplayText] = useState("");
  const [loading, setLoading] = useState("");
  const [locallocationName, setLocalLocationName] = useState("");
  const [activeProvince, setActiveProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
// console.log(displayText);
  const navigate = useNavigate();
  const location = useLocation();
  const mapLink = location.pathname?.split("rollzicecream/v2/")?.slice(-1);
  const[storedLocation, setStoredLocation] = useState('')

  useEffect(() => {
    const storedLocation = localStorage.getItem("location_name")?.toLowerCase();
    // console.log("storedLocation", storedLocation);
    setStoredLocation(storedLocation)
    const currentLocation = locationArray.find(loc => loc == storedLocation)
    if (currentLocation) {
      setDisplayText(currentLocation);
    } else {
      setDisplayText("Ajax");
    }
    onLocation();
    onProvinces();
    if (localStorage.getItem("location") != null) {
      if (category?.length == 0) {
        onMenuCategory();
      }
    }

    fetchAnnouncement();
  }, [call, locallocationName]);

  // console.log("cdcsd", storedLocation)

  const [data, setData] = useState([]);

  const onLocation = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${config.apiUrl}/locations`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      setData(response.data.data.filter((loc)=> loc.status === 1));
      // console.log("data", response.data.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const onProvinces = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${config.apiUrl}/website-provinces`, 
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      const provData = response.data.data;
      setProvinces(provData);
      if (provData?.length > 0) {
        setActiveProvince(provData[0].id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [category, setCategoryList] = useState([]);

  const onMenuCategory = async () => {
    setLoading(false);
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location"));
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/product_category`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        setCategoryList(response.data.data);
        setLoading(false);
        // console.log("Navbar Category list", response.data.data);
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // Fetching Announcement Text
  const [announcementText, setAnnouncement] = useState("");
  const fetchAnnouncement = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${config.apiUrl}/announcement`,
        headers: {
          Accept: "application",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);
        setAnnouncement(res.data.data?.value);
        // console.log("Annou", res.data.data?.value);
      });
    } catch (error) {
      setLoading(false);
      console.log("fetch Announcement", error);
    }
  };

  window.addEventListener("scroll", () => {
    if (window.scrollY > 50) {
      setStickyNavbar(true);
    } else {
      setStickyNavbar(false);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key == "Escape") {
      setShowLocations(false);
    }
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  // console.log("displayText", displayText);
  return (
    <div className="navbar_cont">
      <nav className={`navibar  stickyNav ${stickyNavbar ? "fixedNav" : ""}`}>
        {/* <div className={`top_heading px-3 py-2`} style={{backgroundColor: stickyNavbar ? "#0274c2" : "#ee1e79"}} > */}
        <div
          className={`top_heading px-2 py-2 ${
            stickyNavbar ? "d-none" : "d-block"
          }`}
        >
          <h6 className="text-center head_line mb-0">
            {/* <marquee behavior="scroll" direction="right" className="p-1 marqueFont">
              {repeatedText}
            </marquee> */}

            <RollingMarquee
              text={announcementText}
              // highlight="Surrey"
              symbol1="🤩"
              symbol2="🍦"
            />
          </h6>
        </div>

        <div className={` position-relative nav_container `}>
          <div className="mian_navbar py-2">
            <div className="navbar-brand-container">
              <Link to={`${config.appUrl}`} className="navbar-brand">
                <img
                  src={logo2}
                  alt="Logo"
                  onClick={() => window.scrollTo(0, 0)}
                ></img>
              </Link>
            </div>

            <div
              className={`navlinl_container ${
                stickyNavbar ? "fadenavLinkCont" : ""
              }`}
            >
              <ul
                className={`navlinks ${stickyNavbar && "Stickynavlinks"} ${
                  mobileNavbar && "show_navbar"
                }`}
              >
                <li className="menu_item">
                  <Link
                    className="d-flex align-items-center justify-content-center gap-1"
                  >
                    Menu
                    <BiCaretDown />
                  </Link>

                  <ul className="text-center children-list px-2 py-1">
                    {categoryList
                      .filter((obj) => obj.subcategory !== 1)
                      ?.map((obj, i) => {
                        if (obj.is_active == 1) {
                          return (
                            <li
                              key={obj.id}
                              className="children-item"
                              style={{ zIndex: 1 }}
                            >
                              <Link
                                to={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-")}/${obj.slug}`}
                                className="children-link"
                                style={{ zIndex: 999 }}
                                onClick={() => setMobileNavbar(false)}
                              >
                                {obj.menu_name}
                              </Link>
                            </li>
                          );
                        }
                      })}
                  </ul>
                </li>

                <li className="location_item">
                  <Link
                    className="d-flex align-items-center justify-content-center gap-1"
                  >
                    Locations
                    <i className="bi bi-caret-down"></i>
                  </Link>

                  <div className="province_mega_menu">
                    {/* Left: Province sidebar */}
                    <div className="province_sidebar">
                      <p className="province_sidebar_title">Provinces</p>
                      {provinces.map((province) => (
                        <div
                          key={province.id}
                          className={`province_list_item ${activeProvince === province.id ? "prov_active" : ""}`}
                          onMouseEnter={() => setActiveProvince(province.id)}
                          onClick={() => setActiveProvince(province.id)}
                        >
                          <span>{province.name}</span>
                          <div className="d-flex align-items-center gap-1">
                            <span className="prov_count_badge">
                              {data.filter((loc) => loc.province_id === province.id && loc.is_active === 1).length}
                            </span>
                            <i className="bi bi-chevron-right prov_arrow"></i>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Right: Locations panel */}
                    <div className="province_locs_panel">
                      <p className="prov_locs_header">
                        <i className="bi bi-geo-alt-fill me-1"></i>
                        {provinces.find((p) => p.id === activeProvince)?.name} Locations
                      </p>
                      <div className="prov_locs_grid">
                        {data
                          .filter((loc) => loc.province_id === activeProvince && loc.is_active === 1)
                          .map((loc) => (
                            <Link
                              key={loc.id}
                              to={`${config.appUrl}/${loc.location_name.toLowerCase().replaceAll(",", "").replaceAll(" ", "-")}`}
                              className="prov_loc_card"
                              onClick={() => {
                                setDisplayText(loc.location_name.toLowerCase());
                                localStorage.setItem("location", loc.id);
                                localStorage.setItem("location_name", loc.location_name);
                                setLocationName && setLocationName(loc.location_name);
                                setMobileNavbar(false);
                              }}
                            >
                              <div className="prov_loc_img">
                                <img src={loc.image} alt={loc.location_name} />
                              </div>
                              <span className="prov_loc_name">{loc.location_name}</span>
                            </Link>
                          ))}
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <Link
                    to={`${config.appUrl}/franchise`}
                    onClick={() => setMobileNavbar(false)}
                  >
                    Franchise
                  </Link>
                </li>
                <li>
                  <Link
                    to={`${config.appUrl}/our-story`}
                    onClick={() => setMobileNavbar(false)}
                  >
                    Our Story
                  </Link>
                </li>
                <li>
                  <Link
                    to={`${config.appUrl}/contact-us`}
                    onClick={() => setMobileNavbar(false)}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            <div
              className={`location_box d-flex align-items-center justify-content-center px-md-3 `}
            >
              <p
                className={`pt-1 ${stickyNavbar && "locationTitle"}`}
                onClick={() => setShowLocations(true)}
              >
                <i className="bi bi-geo-alt-fill"></i>
                {/* <span>Ajax</span> */}
                <span>
                  {/* {displayText?.toLocaleLowerCase().replace(/\b\w/g, char => char.toLocaleUpperCase() || "Ajax"} */}
                  {/* {localStorage.getItem("location_name")
                    ? localStorage
                        .getItem("location_name")
                        ?.toLowerCase()
                        ?.replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalizes first letter of each word
                    : "Ajax"} */}

                    {
                      localStorage
                      .getItem("location_name")
                      ?.toLowerCase()
                      ?.replace(/\b\w/g, (char) => char.toUpperCase())
                    }
                    {/* {location} */}
                </span>
                {/* <i className="bi bi-geo-alt-fill" style={{color: stickyNavbar ? "#ee1e79" : "white"}}></i>
                <span style={{color: stickyNavbar ? "#ee1e79" : "white"}}>Ajax</span> */}
              </p>

              <button
                className="menu_btn ms-4"
                aria-label="menu_btn"
                onClick={() => setMobileNavbar((prev) => !prev)}
              >
                {mobileNavbar ? <FaXmark /> : <FaBars />}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Location MOdal  */}
      <Modal show={showLocations} size="lg" centered className="modal">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Our Locations</h5>
          <button
            type="button"
            title="Close Modal"
            onClick={() => {
              setShowLocations(false);
            }}
            className="btn-modal-close text-white"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <h5 className="">Pick Your Location !</h5>

          <div className="d-flex flex-wrap align-items-center justify-content-ceter gap-2 py-4">
            {/* {locationsOptions.map((item) => (
              <div className="locations">
                <p>{item.locationName}</p>
              </div>
            ))} */}
            {data.map((obj, i) => {
              return (
                <div className="locations" key={i}>
                  <Link
                    to={`${
                      config.appUrl
                    }/${obj.location_name.toLowerCase().replaceAll(",","").replaceAll(" ","-")}`}
                    onClick={() => {
                      setShowLocations(false);
                      setDisplayText(obj.location_name);
                      localStorage.setItem("location", obj.id);
                      localStorage.setItem("location_name", obj.location_name);
                      setLocationName && setLocationName(obj.location_name);

                      // Redirecting to location page
                      navigate(`${config.appUrl}/`);

                      // setTimeout(() => window.location.reload(), 500);
                      // window.location.href = '/' 

                    }}
                    style={{ cursor: "pointer" }}
                    className="mb-0"
                  >
                    {obj.location_name}
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Navbar;
